import { render, staticRenderFns } from "./UiData.vue?vue&type=template&id=3dc4fe9c&scoped=true"
import script from "./UiData.vue?vue&type=script&lang=js"
export * from "./UiData.vue?vue&type=script&lang=js"
import style0 from "./UiData.vue?vue&type=style&index=0&id=3dc4fe9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc4fe9c",
  null
  
)

export default component.exports